import React, { Component } from 'react';
import { Col } from 'react-bootstrap';
import { Button } from "react-bootstrap";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { userActions } from '../store/Authentication';
import Header from '../components/Header';
import AlertPanel from '../components/AlertPanel';
import Loading from '../components/Loading';

class Logout extends Component {
	constructor(props) {
		super(props);

		this.handleSubmit = this.handleSubmit.bind(this);
	}

	handleSubmit = event => {
		event.preventDefault();

		// reset ogout status
		this.props.logout();
	}

	render() {
		const { error, loggingOut } = this.props;
		return (
			<div>
				<Header title="Log Out" />
				<Col sm={{ span: 6, offset: 3 }}>
					<form onSubmit={this.handleSubmit}>
					{error ? <AlertPanel type="danger" message={error} /> : []}
					<p>Do you really want to log out?</p>
						{loggingOut
							? <Loading />
              : <Button
                className="btn btn-default"
								block
								bsSize="large"
								type="submit"
							  >
								Log Out
							</Button>
						}
					</form>
				</Col>
			</div>
		);
	}
}

export default connect(
	state => state.authentication,
	dispatch => bindActionCreators(userActions, dispatch)
)(Logout);